import React, { Suspense } from 'react';

import './scss/cui-standard.scss';
import './scss/custom.scss';

import { Router } from 'react-router';
import { Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk';
import rootReducer from './redux/reducers';

import AppLayout from './components/AppLayout/AppLayout';
import Security from './components/Security/Security';
import Version from './components/Version/Version';
import { HotKeys } from './components/HotKeys/HotKeys';

import RouteNotFound from './components/Routes/RouteNotFound/RouteNotFound';
import InvalidSession from './components/Routes/InvalidSession/InvalidSession';
import LTISessionExpired from './components/Routes/LTISessionExpired/LTISessionExpired';
import InvalidCourse from './components/Routes/InvalidCourse/InvalidCourse';
import Loader from './components/Block/common/Loading/Loading';
import Splash from './components/Splash/Splash';
export const history = createBrowserHistory();

const baseUrl = process.env.PUBLIC_URL;

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducer,
  composeEnhancer(applyMiddleware(ReduxThunk))
);

const App = () => {
  return (
    <Suspense fallback={<Loader context="App" />}>
      <Security>
        <Version>
          <Router history={history} basename={baseUrl}>
            <Provider store={store}>
              <HotKeys>
                <Switch>
                  <Route path="/not-found">
                    <RouteNotFound />
                  </Route>
                  <Route path="/invalid-session">
                    <InvalidSession />
                  </Route>
                  <Route path="/invalid-course">
                    <InvalidCourse />
                  </Route>
                  <Route path="/session-expired">
                    <LTISessionExpired />
                  </Route>
                  <Route exact path="/">
                    <Splash />
                  </Route>
                  <Route path="*">
                    <AppLayout />
                  </Route>
                </Switch>
              </HotKeys>
            </Provider>
          </Router>
        </Version>
      </Security>
    </Suspense>
  );
};

export default App;
